import { inject, reactive, watch, nextTick, ref, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { languageService } from '@/utils';
import { gaService } from "@/utils";
export default {
  name: "sidebar",
  setup() {
    const {
      gaTrackButtonClick
    } = gaService;
    const {
      getLanguagePath
    } = languageService;
    const currentLangPath = computed(() => getLanguagePath());
    const route = useRoute();
    const router = useRouter();
    const {
      sidebar
    } = inject("store");
    const state = reactive({
      activeLink: null,
      sidebarCloseWidth: 64,
      sidebarOpenWidth: 265
    });
    const getDefaultActiveLink = route => {
      //detail page 
      if (route.query.v) {
        return '';
      }

      //other page
      let routePath = route.path.replace(currentLangPath.value, "").split('/')[0];
      if (routePath && routePath.toLowerCase() !== 'home') {
        return routePath;
      } else {
        return "home";
      }
    };
    const routerPush = element => {
      let path = currentLangPath.value;
      if (element.index != "home") {
        path += element.index;
      }
      router.push(path);
    };
    const switchWindowScrollbar = () => {
      if ($(window).width() <= 1312 && !sidebar.states.isSidebarClose) {
        $('body').addClass("stop-scroll");
      } else {
        $('body').removeClass("stop-scroll");
      }
    };
    const closeSidebar = () => {
      if ($(window).width() <= 1312) {
        sidebar.mutations.switchSidebarClose(false);
        sidebar.mutations.switchUserClose(false);
      }
    };
    watch(route, to => {
      state.activeLink = getDefaultActiveLink(to);
      bindResize();
    });
    watch(() => sidebar.states.isSidebarClose, () => {
      switchWindowScrollbar();
    });
    nextTick(() => {
      $('#fill-sidebar-gap').css('width', $('#sidebar').width());
      state.activeLink = getDefaultActiveLink(route);
    });
    let originalWidth = $(window).width();
    const checkWindowWidthToSwitchSidebar = () => {
      if (sidebar.states.isUserClose === null) {
        if ($(window).width() <= 1312 && !sidebar.states.isSidebarClose) {
          sidebar.mutations.switchSidebarClose(false);
        } else if ($(window).width() > 1312 && sidebar.states.isSidebarClose) {
          sidebar.mutations.switchSidebarClose(true);
        }
      } else {
        if (sidebar.states.isUserClose) {
          sidebar.mutations.switchSidebarClose(false);
        } else if (originalWidth > 1312 && $(window).width() < 1312) {
          sidebar.mutations.switchSidebarClose(false);
        } else if (originalWidth < 1312 && $(window).width() > 1312) {
          sidebar.mutations.switchSidebarClose(true);
        }
      }
      originalWidth = $(window).width();
      setTimeout(() => {
        switchWindowScrollbar();
      }, 0);
    };
    let checkWindowWidthToCloseSidebarTimer = null;
    const ResizeEvent = function () {
      clearTimeout(checkWindowWidthToCloseSidebarTimer);
      checkWindowWidthToCloseSidebarTimer = setTimeout(() => {
        checkWindowWidthToSwitchSidebar();
      }, 250);
    };
    const bindResize = () => {
      window.removeEventListener("resize", ResizeEvent);
      window.addEventListener("resize", ResizeEvent, false);
    };
    bindResize();
    checkWindowWidthToSwitchSidebar();
    return {
      sidebar,
      state,
      closeSidebar,
      gaTrackButtonClick,
      currentLangPath,
      routerPush
    };
  }
};